module.exports = __webpack_public_path__ + "img/logo-default.a43fed94.png";